<template>
  <div class="imei-history">
    <KTCodePreview v-bind:title="'Lịch sử sản phẩm'">
      <template v-slot:preview>
        <b-row class="mb-5">
          <b-col>
            <b-input
              size="sm"
              placeholder="Nhập mã, tên sản phẩm"
              v-model="searchProduct"
              v-on:keyup.enter="onFilter()"
            ></b-input>
          </b-col>
          <b-col>
            <b-input
              size="sm"
              placeholder="Nhập SK/SM"
              v-model="searchChassisEngine"
              v-on:keyup.enter="onFilter()"
            ></b-input>
          </b-col>
          <b-col>
            <b-input
              size="sm"
              placeholder="Nhập Số Seri"
              v-model="searchSerialNumber"
              v-on:keyup.enter="onFilter()"
            ></b-input>
          </b-col>
          <b-col>
            <div class="search-col">
              <b-input-group>
                <date-picker
                  placeholder="Từ ngày"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="searchFromDay"
                ></date-picker>
              </b-input-group>
              <span class="ml-1 mr-1"></span>
              <b-input-group>
                <date-picker
                  placeholder="Đến ngày"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="searchToDay"
                ></date-picker>
              </b-input-group>
            </div>
          </b-col>
          <b-col>
            <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedAction"
              :options="listAction"
              value-field="id"
              text-field="name"
              v-on:change="fetchData"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col md="1">
            <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc
            </b-button>
          </b-col>
        </b-row>
        <b-table
          :items="listProductHistory"
          :fields="fields"
          :bordered="true"
          :hover="true"
          :busy="onLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>
          <template v-slot:cell(action)="row">
            <span v-text="getActionMapping(row.item.action)"></span>
            <br />
            <span v-text="row.item.storeName" style="color: blue"></span>
          </template>
          <template v-slot:cell(productName)="row">
            <p v-if="row.item.productCode" style="font-size: 11px; margin-bottom: 0">
              {{ row.item.productCode }}
            </p>
            <span v-text="row.item.productName" style="white-space: normal"></span>
          </template>
          <template v-slot:cell(reference)="row">
            <div
              class="d-flex justify-content-center billCode"
              @click="linkToReference(row.item)"
              style="cursor: pointer"
            >
              <span v-text="getReferenceIdByAction(row.item)"></span>
            </div>
          </template>
          <template v-slot:cell(chassisEngine)="row">
            <div class="d-flex justify-content-center billCode" style="cursor: pointer">
              <span v-if="row.item.chassisNumber">
                SK: {{ row.item.chassisNumber }}<br />SM: {{ row.item.engineNumber }}
              </span>
            </div>
          </template>
          <template v-slot:cell(serialNumber)="row">
            <div class="d-flex justify-content-center billCode" style="cursor: pointer">
              <span v-text="row.item.serialNumber"></span>
            </div>
          </template>
          <template v-slot:cell(createdBy)="row">
            <span v-text="row.item.createdBy"></span>
          </template>
          <template v-slot:cell(createdAt)="row">
            <span v-text="formatDate(row.item.createdAt)"></span>
          </template>
        </b-table>
        <b-row>
          <b-col>
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng số:
              {{ convertPrice(totalItem) }}
            </p>
          </b-col>
          <div class="d-flex justify-content-end">
            <b-col>
              <BPaginationNavCustom
                :number-of-pages="numberOfPage"
                :current-page="currentPage"
                :total-page="totalItem"
                :linkParams="linkParams"
                @page-change="fetchData()"
              >
              </BPaginationNavCustom>
            </b-col>
          </div>
        </b-row>
      </template>
    </KTCodePreview>
  </div>
</template>

<style lang="scss">
.imei-history {
  .labelInput {
    font-weight: 600;
  }

  .productCode:hover {
    text-decoration: underline;
  }

  .page-item.disabled {
    cursor: not-allowed;

    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }

  .icon:hover {
    background-color: #90c6fc;
  }

  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }

  .table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
  .table.b-table.table-sm > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
    background-position: right calc(1.5rem / 2) center;
    padding-right: calc(0.3rem + 0.65em);
  }

  .billCode:hover {
    text-decoration: underline;
  }

  .search-col {
    display: flex;
    align-items: center;
  }
}
</style>
<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import { SET_BREADCRUMB } from "@/core/services/store/modules/breadcrumbs.module";
import ApiService from "@/core/services/api.service";
import localData from "../../../utils/saveDataToLocal";
import { VclTable } from "vue-content-loading";
import decounce from "debounce";
import moment from "moment";
import { getCurrentDate, getSubtractDate } from "@/utils/date";
import { DATE_LENGTH } from "@/utils/constants";
import {
  PRODUCT_HISTORY_ACTION,
  PRODUCT_HISTORY_ACTION_MAPPING,
  STOCK_SLIP_TYPE,
} from "@/utils/enum";
import BPaginationNavCustom from "@/view/base/bootstrap/BPaginationNavCustom.vue";
import { DP_CONFIG, formatDate } from "@/utils/date";

export default {
  data() {
    return {
      selectedProduct: "",
      listProductHistory: [],
      fields: [
        {
          key: "count",
          label: "STT",
          thStyle: { textAlign: "center", width: "5%" },
          tdClass: "text-center",
        },
        {
          key: "action",
          label: "Hành động",
          sortable: false,
          thStyle: {
            textAlign: "center",
            color: "rgb(24, 28, 50)",
            width: "7%",
          },
        },
        {
          key: "reference",
          label: "Thông tin đối chiếu",
          sortable: false,
          thStyle: {
            textAlign: "center",
            color: "rgb(24, 28, 50)",
            width: "12%",
          },
        },
        {
          key: "chassisEngine",
          label: "Số khung/Số máy",
          sortable: false,
          thStyle: {
            textAlign: "center",
            color: "rgb(24, 28, 50)",
            width: "12%",
          },
        },
        {
          key: "serialNumber",
          label: "Số seri",
          sortable: false,
          thStyle: {
            textAlign: "center",
            color: "rgb(24, 28, 50)",
            width: "12%",
          },
        },
        {
          key: "productName",
          label: "Sản phẩm",
          sortable: false,
          thStyle: {
            textAlign: "center",
            color: "rgb(24, 28, 50)",
            width: "12%",
          },
        },
        {
          key: "providerName",
          label: "Nhà cung cấp",
          thStyle: {
            textAlign: "center",
            color: "rgb(24, 28, 50)",
            width: "12%",
          },
        },
        {
          key: "createdBy",
          label: "Nhân viên thực hiện",
          thStyle: {
            textAlign: "center",
            color: "rgb(24, 28, 50)",
            width: "12%",
          },
          tdClass: "width: 15%",
        },
        {
          key: "createdAt",
          label: "Ngày tạo",
          thStyle: {
            textAlign: "center",
            color: "rgb(24, 28, 50)",
            width: "10%",
          },
          tdClass: "width: 15%",
        },
      ],
      searchChassisEngine: "",
      searchSerialNumber: "",
      linkGen: (pageNum) => {
        return pageNum === 1 ? "?" : `?page=${pageNum}`;
      },
      page: 1,
      totalItem: 0,
      selectedAction: null,
      listAction: [
        { id: null, name: "Tất cả hành động" },
        ...Object.keys(PRODUCT_HISTORY_ACTION_MAPPING).map((action) => ({
          id: action,
          name: PRODUCT_HISTORY_ACTION_MAPPING[action],
        })),
      ],
      onLoading: false,
      numberOfPage: 0,
      searchProduct: "",
      dpConfigs: DP_CONFIG,
      searchFromDay: "",
      searchToDay: "",
    };
  },
  components: {
    KTCodePreview,
    VclTable,
    BPaginationNavCustom,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Sản phẩm", route: "/product-history" },
      { title: "Lịch sử sản phẩm" },
    ]);
  },
  created() {
    this.searchFromDay = getSubtractDate(DATE_LENGTH.WEEK);
    this.searchToDay = getCurrentDate();
    this.fetchData();
  },
  methods: {
    formatDate,
    convertPrice: function (number) {
      if (!number) return 0;
      return new Intl.NumberFormat("vn-VN").format(number);
    },
    fetchData: function () {
      this.onLoading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;

      const param = {
        page: this.page,
        limit: 10,
        action: this.selectedAction,
        searchChassisEngine: this.searchChassisEngine || "",
        searchProduct: this.searchProduct || "",
        searchSerialNumber: this.searchSerialNumber || "",
        fromDate: this.searchFromDay
          ? moment(this.searchFromDay, "DD/MM/YYYY").format("yyyy-MM-DD 00:00:00")
          : null,
        toDate: this.searchToDay
          ? moment(this.searchToDay, "DD/MM/YYYY").format("yyyy-MM-DD 23:59:59")
          : null,
      };

      let paramQuery = {
        params: param,
      };

      ApiService.query("product-history", paramQuery)
        .then(({ data }) => {
          this.listProductHistory = [];
          this.numberOfPage = data.data.paginations.totalPages;
          this.totalItem = data.data.paginations.total;
          data.data.data.forEach((element, index) => {
            let count = 0;
            if (this.page === 1) {
              count = index + 1;
            } else {
              count = index + 1 + (this.page - 1) * 10;
            }
            let item = {
              count: count,
              productName:
                element?.productChassis?.product?.name ||
                element?.productSeries?.product?.name,
              productCode:
                element?.productChassis?.product?.code ||
                element?.productSeries?.product?.code,
              providerName:
                element?.productChassis?.provider?.name ||
                element?.productSeries?.provider?.name,
              action: element.action,
              chassisNumber: element?.productChassis?.chassisNumber,
              engineNumber: element?.productChassis?.engineNumber,
              serialNumber: element?.productSeries?.serialNumber,
              createdBy: element?.createdBy?.fullName,
              stockSlipId: element?.stockSlipId,
              stockSlipCode: element?.stockSlip?.code,
              createdAt: element.createdAt,
              stockSlipTransferId: element?.stockSlipTransferId,
              stockSlipTransferCode: element?.stockSlipTransfer?.code,
              billNumber: element?.bill?.billNumber,
              storeName: this.getStoreNameByAction(element),
            };
            this.listProductHistory.push(item);
          });
          this.onLoading = false;
        })
        .catch((e) => {
          this.listProductHistory = [];
          this.numberOfPage = 0;
          this.totalItem = 0;
          this.$bvToast.toast("Lấy dữ liệu thất bại", {
            title: "Thông báo",
            variant: "danger",
            solid: true,
          });
          console.error("Error fetching product history data", e);
          this.onLoading = false;
        });
    },
    editItem: function (item) {
      this.$router.push({
        path: "imeis/update-imei",
        query: { id: item.id },
      });
    },
    checkPermission: function (condition) {
      return localData.checkPermission(condition);
    },
    linkToImei: function (item) {
      const { href } = this.$router.resolve({
        name: "list-imeis",
        query: { code: item.imeiCode },
      });
      window.open(href, "_blank");
    },
    debounceInput: decounce(function () {
      this.fetchData();
    }, 2000),
    onFilter() {
      this.$route.query.page = 1;
      this.fetchData();
    },
    linkToReference(item) {
      const link = this.getLinkByAction(item);
      if (link) window.open(link, "_blank");
    },
    getLinkByAction(item) {
      switch (item.action) {
        case PRODUCT_HISTORY_ACTION.EXPORT_STOCK:
        case PRODUCT_HISTORY_ACTION.UPDATE_EXPORT_STOCK_SLIP:
          return `#/export-stocks/update-export-stock?id=${item.stockSlipId}`;
        case PRODUCT_HISTORY_ACTION.IMPORT_STOCK:
        case PRODUCT_HISTORY_ACTION.UPDATE_IMPORT_STOCK_SLIP:
          return `#/stocks/update-stock?id=${item.stockSlipId}`;
        case PRODUCT_HISTORY_ACTION.TRANSFER_STOCK:
        case PRODUCT_HISTORY_ACTION.CANCEL_STOCK_SLIP_TRANSFER:
          return `#/transfer-stocks/update-transfer-stock?id=${item.stockSlipTransferId}`;
        case PRODUCT_HISTORY_ACTION.EXPORT_STOCK_TO_SALE:
        case PRODUCT_HISTORY_ACTION.EXPORT_STOCK_TO_SALE_WHOLSE:
        case PRODUCT_HISTORY_ACTION.UPDATE_BILL:
          return `#/bills/update-bill?id=${item.billNumber}`;
        default:
          return "";
      }
    },
    getActionMapping(action) {
      return (
        PRODUCT_HISTORY_ACTION_MAPPING[action] || PRODUCT_HISTORY_ACTION_MAPPING.UNKNOWN
      );
    },
    getReferenceIdByAction(item) {
      switch (item.action) {
        case PRODUCT_HISTORY_ACTION.EXPORT_STOCK:
        case PRODUCT_HISTORY_ACTION.UPDATE_EXPORT_STOCK_SLIP:
        case PRODUCT_HISTORY_ACTION.IMPORT_STOCK:
        case PRODUCT_HISTORY_ACTION.UPDATE_IMPORT_STOCK_SLIP:
        case PRODUCT_HISTORY_ACTION.DELETE_EXPORT_STOCK_SLIP:
        case PRODUCT_HISTORY_ACTION.DELETE_IMPORT_STOCK_SLIP:
          return item?.stockSlipCode || "";
        case PRODUCT_HISTORY_ACTION.TRANSFER_STOCK:
        case PRODUCT_HISTORY_ACTION.DELETE_TRANSFER_STOCK_SLIP:
        case PRODUCT_HISTORY_ACTION.CANCEL_STOCK_SLIP_TRANSFER:
          return item?.stockSlipTransferCode || "";
        case PRODUCT_HISTORY_ACTION.EXPORT_STOCK_TO_SALE:
        case PRODUCT_HISTORY_ACTION.EXPORT_STOCK_TO_SALE_WHOLSE:
        case PRODUCT_HISTORY_ACTION.UPDATE_BILL:
        case PRODUCT_HISTORY_ACTION.DELETE_BILL:
          return item?.billNumber || "";
        default:
          return item?.stockSlipCode || item?.stockSlipTransferCode || "";
      }
    },
    getStoreNameByAction(item) {
      switch (item.action) {
        case PRODUCT_HISTORY_ACTION.IMPORT_STOCK:
          if (item?.stockSlip?.type === STOCK_SLIP_TYPE.IMPORT_PROVIDER) {
            return item.stockSlip?.sourceWarehouse?.name || "Không xác định";
          } else {
            return item.stockSlip?.destinationWarehouse?.name || "Không xác định";
          }
        case PRODUCT_HISTORY_ACTION.EXPORT_STOCK:
        case PRODUCT_HISTORY_ACTION.UPDATE_EXPORT_STOCK_SLIP:
        case PRODUCT_HISTORY_ACTION.DELETE_EXPORT_STOCK_SLIP:
        case PRODUCT_HISTORY_ACTION.EXPORT_STOCK_TO_SALE:
        case PRODUCT_HISTORY_ACTION.EXPORT_STOCK_TO_SALE_WHOLSE:
        case PRODUCT_HISTORY_ACTION.DELETE_BILL:
        case PRODUCT_HISTORY_ACTION.UPDATE_BILL:
          return item?.stockSlip?.sourceWarehouse?.name || "Không xác định";
        case PRODUCT_HISTORY_ACTION.UPDATE_IMPORT_STOCK_SLIP:
        case PRODUCT_HISTORY_ACTION.DELETE_IMPORT_STOCK_SLIP:
          return item?.stockSlip?.destinationWarehouse?.name || "Không xác định";
        case PRODUCT_HISTORY_ACTION.TRANSFER_STOCK:
        case PRODUCT_HISTORY_ACTION.CANCEL_STOCK_SLIP_TRANSFER:
        case PRODUCT_HISTORY_ACTION.DELETE_TRANSFER_STOCK_SLIP:
          return (
            item?.stockSlipTransfer?.sourceWarehouse?.name +
              " -> " +
              item?.stockSlipTransfer?.destinationWarehouse?.name || "Không xác định"
          );
        default:
          return "Không xác định";
      }
    },
  },
};
</script>
